/**
 * The review of a recognized laboratory draft as rows under their print: the
 * crops, report dates, codes and their automatic mark, Needs attention, the
 * unsaved-edits question, and a confirmed report's provenance. The review's
 * field names are `laboratory.ts`.
 */
export const laboratoryReview = {
  'lab.review.reportGroup': 'Report {number}',
  'lab.review.collectionDate': 'Collected: {when}',
  'lab.review.resultDate': 'Result: {when}',
  'lab.review.dateMissing': 'Set a collection or report date',
  'lab.review.individualDates': 'Individual dates',
  'lab.review.editDates': 'Edit dates for this result',
  'lab.review.inheritDates': 'Use report dates',
  'lab.review.catalogTitle': 'Choose a laboratory test',
  'lab.review.catalogMore': 'Load more codes',
  'lab.review.codingChoose': 'Choose code',
  'lab.review.codingChange': 'Change code',
  'lab.review.automatic': 'Automatic',
  'lab.review.automaticDetail':
    'This code was chosen automatically. Confirming the report accepts it; choose another code to replace it.',
  'lab.review.codingSearch': 'Search the laboratory catalog',
  'lab.review.codingClear': 'Remove the code',
  'lab.review.suggestions': 'Suggested codes',
  'lab.review.attentionConfidence': 'Read with low confidence',
  'lab.review.attentionUnmapped': 'No catalog code',
  'lab.review.attentionAutomatic': 'The automatic code is uncertain',
  'lab.review.attentionUnplaced': 'Not found on the page',
  'lab.review.cropOpen': 'Open page {page} with this row outlined',
  'lab.review.cropMissing': 'Not found on page {page}. Open the page',
  'lab.review.cropUnavailable': 'Page {page} could not be drawn',
  'lab.review.page': 'Page {page}',
  'lab.review.addedRows': 'Added rows',
  'lab.review.filterLabel': 'Rows shown',
  'lab.review.filterAll': 'All rows: {count}',
  'lab.review.filterAttention': 'Needs attention: {count}',
  'lab.review.attentionNone': 'No rows need attention.',
  'lab.review.unsavedIntent': 'Edits to recognized laboratory results',
  'lab.review.provenanceTitle': 'Source of the report',
  'lab.review.provenanceSource': 'Source: {name}',
  'lab.review.provenancePages': 'Source: {name}, pages {pages}',
  'lab.review.provenancePagesOf': 'Source: {name}, pages {pages} of {count}',
  'lab.review.provenanceOpen': 'Open',
  'lab.review.provenanceRecognized': 'Recognized {when}',
  'lab.review.provenanceRecognizedBy': 'Recognized {when} by {who}',
  'lab.review.provenanceGoogle': 'Google Document AI',
  'lab.review.provenanceConfirmed': 'Confirmed {when}',
  'lab.review.provenanceConfirmedBy': 'Confirmed {when} by {who}',
  'lab.review.provenanceReplaced': 'Replaced the report of {when} (recognized again)',
  'lab.review.reRecognized': 'Replaced by a new recognition of the same document',
} as const
